var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titlebar-only-text row-container"},[_c('h1',[_vm._v(_vm._s(_vm.msg.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.msg.subtitle)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }